export const CASH_APP = (communityId: string) =>
  `v1/community/${communityId}/uje/cash-app`;
